module.exports = require("cors");